import abcoLogo from "assets/abco-logo.png";
import ItemStatusBadge from "components/item/ItemStatusBadge";
import { Box, FormattedCurrency, HStack, Image, Link } from "components/ui";
import ItemBadge from "components/ui/ItemBadge";
import { Paragraph, Typography } from "components/ui/Typography";
import React, { useMemo } from "react";
import { Platform } from "react-native";
import { Item, ItemWithQuantity } from "store/abcoApi";
import { getUnitPrice } from "utils/globalFunctions";
import { useSiteSearch } from "utils/hooks/useSiteSearch";

export type ItemListItemBaseProps = {
	itemWithQuantity?: ItemWithQuantity;
	item?: Item;
	isOnNavigation?: boolean;
	location?: number | null;
	onClick?: () => void;
	isOnSearch?: boolean;
};

export const renderItemContent = (itemInfo: Item, variant: "standard" | "checkout" | "stocklist" | "order" = "standard", location: number | null = null, onClick?: () => void, itemWithQuantity?: ItemWithQuantity) => {
	
	const unitPrice = getUnitPrice(itemWithQuantity?.item, itemWithQuantity?.quantity);

	const { close } = useSiteSearch();
	return (
		<>
			{itemInfo.stockcode && <ItemBadge stockcode={itemInfo.stockcode} />}
			<Link onPress={onClick} href={`/${itemInfo.slug}`}>
				{Platform.OS === "web" ? (
					<h4 className="item-list-base-title">{itemInfo.name ? itemInfo.name : "No Item name detected"}</h4>
				) : (
					<Typography.H4 weight="bold">{itemInfo.name ? itemInfo.name : "No Item name detected"}</Typography.H4>
				)}
			</Link>

			{variant === "standard" && (
				<HStack gap={8} justifyContent="center" alignItems="center">
					<HStack flex={1} gap={8} alignItems="center" justifyContent="space-between">
						<HStack gap={8} alignItems="center">
							<FormattedCurrency sx={{ fontSize: "$h3desktop", lineHeight: 40, fontWeight: "bold" }} amount={itemInfo.unitPrice} />
							{typeof itemInfo.unitPrice === "number" && typeof itemInfo.tradePrice === "number" && itemInfo.unitPrice < itemInfo.tradePrice && (
								<FormattedCurrency
									sx={{
										flex: 1,
										fontSize: "$h4mobile",
										color: "$neutral500",
										textDecorationLine: "line-through",
										fontFamily: "inter",
									}}
									amount={itemInfo.tradePrice}
								/>
							)}
						</HStack>
						<ItemStatusBadge item={itemInfo} location={location} />
					</HStack>
				</HStack>
			)}
			{variant === "checkout" && (
				<HStack alignItems="center" paddingVertical={6} gap={8}>
					<HStack gap={8} alignItems="center">
						<Paragraph weight="normal">Item price:</Paragraph>
						<FormattedCurrency amount={unitPrice} />
						{unitPrice < itemInfo.tradePrice && (<FormattedCurrency
							sx={{
								flex: 1,
								fontSize: "$h6mobile",
								color: "$neutral500",
								textDecorationLine: "line-through",
								fontFamily: "inter",
							}}
							amount={itemInfo.tradePrice}
							/>
						)}
					</HStack>
					<ItemStatusBadge item={itemInfo} location={location} />
				</HStack>
			)}
		</>
	);
};

export const renderItemImage = (itemInfo: Item, onClick?: any) => {
	const { close: closeSiteSearch } = useSiteSearch();
	return (
		<Box flex={1} padding={itemInfo.imageUrl ? 0 : 10} bg="$basicwhite" maxWidth={140} aspectRatio={35 / 26} borderRadius={20}>
			<Link
				onPress={onClick}
				href={`/${itemInfo.slug}`}
				pressableStyle={{ display: "flex", width: "100%", height: "100%" }}
				component={(hovered: boolean) => {
					if (!itemInfo.imageUrl) {
						return (
							<Box w={"$full"} h={"$full"} maxHeight={280} overflow="hidden">
								<Image
									alt={itemInfo.name || "Product image"}
									bg="$basicwhite"
									sx={{
										width: "100%",
										height: "100%",
										maxHeight: 120,
									}}
									resizeMode="contain"
									borderRadius={20}
									opacity={0.3}
									// @ts-ignore
									style={{ filter: "grayscale(100%)" }}
									source={abcoLogo}
								/>
							</Box>
						);
					}
					return (
						<Box w={"$full"} h={"$full"} maxHeight={280} overflow="hidden">
							<Image
								alt={itemInfo.name || "Product image"}
								bg="$basicwhite"
								sx={{
									width: "100%",
									height: "100%",
								}}
								resizeMode="contain"
								style={{
									transform: hovered ? "scale(1.05)" : "scale(1)",
									// @ts-ignore
									transition: "transform 0.3s ease",
									opacity: hovered ? 0.7 : 1,
								}}
								borderRadius={20}
								// @ts-ignore
								source={process.env.EXPO_PUBLIC_ABCO_API_CDNURL + itemInfo.imageUrl + "?width=200&quality=75&format=webp"}
							/>
						</Box>
					);
				}}
			></Link>
		</Box>
	);
};
